import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DiskCapacityBarInfo = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  position: absolute;
  font-size: ${30 * Screen.widthRatio}px;
  top: ${28 * Screen.widthRatio}px;
  left: ${40 * Screen.widthRatio}px;
`;

export default DiskCapacityBarInfo;
